import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ContributorStripeAccountErrorModel } from 'src/app/admin/models/contributor.stripe.accout.error.model';
import { UserService } from 'src/app/admin/services/user.service';
import { AppUtils } from 'src/app/helpers/app.utils';


@Component({
    selector: 'app-contributor-stripe-account-error',
    templateUrl: './contributor.stripe.account.error.component.html',
})
export class ContributorStripeAccountErrorComponent implements OnInit {
    @Input() public contributorId;
    model = new ContributorStripeAccountErrorModel();

    constructor(public activeModal: NgbActiveModal,
        private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private userService: UserService) {

    }
    ngOnInit(): void {
        setTimeout(() => {
            this.getErrors();
        });
    }



    close(): void {
        this.activeModal.close();
    }

    getErrors() {
        this.ngxSpinnerService.show();
        this.userService.getContributorStripeAccountErrors(this.contributorId).subscribe(
            res => {
                Object.assign(this.model, res);
                if (this.model.status === 4) {
                    this.close();
                    this.toastr.success('Verified successfully.');
                }
                if (this.model.status === 2) {
                    this.close();
                    this.toastr.warning('Pending for verification.');
                }
                this.ngxSpinnerService.hide();
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
